import * as React from "react"

import { cn } from "@/lib/utils"
import { withFirstLetterCapitalized } from "@/lib/autoCapitalize"

/**
 * Textareas are always free text, so first-letter capitalisation applies
 * unconditionally. Opt-out with `data-no-capitalize` (rarely useful — kept
 * for parity with the <Input> primitive).
 */
const Textarea = React.forwardRef(({ className, onChange, ...props }, ref) => {
  const disabled = props["data-no-capitalize"] !== undefined;
  const handleChange = disabled ? onChange : withFirstLetterCapitalized(onChange);
  return (
    <textarea
      onChange={handleChange}
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-sm placeholder:text-muted-foreground focus-visible:outline-none focus-visible:ring-1 focus-visible:ring-ring disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props} />
  );
})
Textarea.displayName = "Textarea"

export { Textarea }
